import {createFileRoute} from '@tanstack/react-router'
import KotcLiveView from '../../kotc/KotcLiveView'
import services from '../../services'
import {config} from '../../config/config'
import {humanizeSlug} from '../../utilities'

export const Route = createFileRoute('/live/kotc/$kotc_uid')({
    component: RouteComponent,
    // Fetch the event server-side so the title/description render in the SSR HTML (SEO).
    // Public endpoint — no auth needed.
    loader: async ({params}) => {
        try {
            const league = await services.leagues.find(params.kotc_uid)
            return {event: league && (league as any).uid ? league : null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.kotc_uid)
        const sport = e?.sport_type ? String(e.sport_type).replace(/_/g, ' ') : 'sports'
        const slug = e?.slug || params.kotc_uid
        return {
            meta: [
                {title: `${name} | Live King of the Court | ScorePal`},
                {name: 'description', content: `Follow ${name} live on ScorePal. Real-time ${sport} King of the Court rounds, court rankings and standings.`},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/kotc/${slug}/`}],
        }
    },
})

function RouteComponent() {
    return <KotcLiveView />
}
